var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('img',{staticClass:"logo",attrs:{"alt":"CloudBase logo","src":require("./assets/cloudbase.png")}}),_c('img',{staticClass:"logo",attrs:{"alt":"Vue logo","src":require("./assets/logo.png")}}),_c('HelloWorld',{attrs:{"msg":"欢迎使用云开发 CloudBase Vue.js App"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }